import { render, staticRenderFns } from "./storeOrderCartReturn.vue?vue&type=template&id=4d2c2fd3&scoped=true"
import script from "./storeOrderCartReturn.vue?vue&type=script&lang=js"
export * from "./storeOrderCartReturn.vue?vue&type=script&lang=js"
import style0 from "./storeOrderCartReturn.vue?vue&type=style&index=0&id=4d2c2fd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2c2fd3",
  null
  
)

export default component.exports